import { GSListPage, defaultLayouts } from "golfstatus_react_components";
import React, { useEffect } from "react";
import { useMatch } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { getRouting } from "../../../../helpers/Converters";
import { eventBaseRoute, TOURNAMENT_ID } from "../../../../routes/event";
import TournamentTVLeaderboards from "./tournament-tv-leaderboards";
import {
  getLeaderboardFlights,
  getPublicLeaderboards,
} from "../../../../reducers/leaderboardSlice";
import {
  getTournamentPaymentSettings,
  getTournamentSponsors,
} from "../../../../reducers/tournamentSlice";
import { useDispatch } from "react-redux";
import { useTournament } from "../../../../hooks/tournamentHooks";

const TournamentTV = (props) => {
  const route = getRouting(eventBaseRoute, [
    TOURNAMENT_ID,
    "leaderboards",
    "tv",
    "*",
  ]);

  const match = useMatch(route);

  const tournament = useTournament();

  const tournamentID = tournament?.id;

  const isSidePanelOpen = () => {
    return match?.params?.["*"] !== "";
  };

  const getRouter = () => {
    return <Outlet />;
  };

  const dispatch = useDispatch();

  useEffect(() => {
    if (tournamentID) {
      dispatch(getPublicLeaderboards(tournamentID));
      dispatch(getTournamentSponsors(tournamentID));
      dispatch(getTournamentPaymentSettings(tournamentID));
      dispatch(getLeaderboardFlights(tournamentID));
    }
  }, [dispatch, tournamentID]);

  return (
    <tournament-tv>
      <GSListPage
        isSidePanelOpen={isSidePanelOpen}
        getRouter={getRouter}
        headerStyle={{ display: "none" }}
        style={{ ...defaultLayouts.fullHeight }}
        searchPage={{
          style: { ...defaultLayouts.fullHeight },
          contentStyle: { ...defaultLayouts.fullHeight },
        }}
      >
        <TournamentTVLeaderboards />
      </GSListPage>
    </tournament-tv>
  );
};

export default TournamentTV;
